import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const profileDetails = createAsyncThunk('profileDetails/profileDetails', async (data) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `user/${localStorage.getItem("id")}`,
        
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
        return res
    } catch (error) {
        return error.response || { status: 500, data: { message: 'Network error or timeout' } }
    }
})

const profileDetailsSlice = createSlice({
    name: 'profileDetails',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(profileDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(profileDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
                state.error = null;
            } else if (action?.payload?.status === 401) {
                state.data = null;
                state.error = 'Unauthorized';
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.error = action.payload?.data?.message || 'Failed to fetch link analysis';
                state.data = null;
            }
        });
        builder.addCase(profileDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message || 'An error occurred';
            state.data = null;
        });
    }
})

export default profileDetailsSlice.reducer;

